import { getCiamSessionToken } from './useCiamAuthorize'

export const useCiamLogout = () => {
  const handleLogout = async () => {
    if (typeof window === 'undefined') {
      return false
    }

    const sessionToken = getCiamSessionToken() ?? ''
    localStorage.removeItem('refId')
    try {
      const response = await fetch(
        `${process.env.GATSBY_API_URL}/ciam/sign-out`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ SessionToken: sessionToken }),
        }
      )

      const contentType = response.headers.get('content-type') ?? ''
      let responseBody
      if (contentType.includes('application/json')) {
        responseBody = await response.json()
      } else {
        responseBody = await response.text()
      }

      const isSignOffSuccessful =
        typeof responseBody === 'object' &&
        responseBody !== null &&
        responseBody.IsSignOffSuccessful === true

      return isSignOffSuccessful
    } catch (err) {
      console.error('Error calling CIAM /ciam/sign-out:', err)
      return false
    }
  }

  return { handleLogout }
}
